const endpoints = {
  reportError: 'api/v2/errors/',
}

export default endpoints
